import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '@/store/store'
import type { ProfileTab } from '@/types/profile'

interface ProfileState {
	activeTab: ProfileTab
}

const initialState: ProfileState = {
	activeTab: 'balances',
}

const profileSlice = createSlice({
	name: 'profile',
	initialState,
	reducers: {
		setActiveTab(state, action: PayloadAction<ProfileTab>) {
			state.activeTab = action.payload
		},
	},
})

export const { setActiveTab } = profileSlice.actions

export const selectActiveProfileTab = (state: RootState) => state.profile.activeTab

export default profileSlice.reducer
